'use client';

import React, { useState } from 'react';
import { PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import { PlanCardsMobileTabs } from './PlanCardsMobileTabs';
import PlansMobile from './PlansMobile';
import { GridColFullWidth } from '@constants/layout';
import cn from '@utils/cn';

type Props = {
  data: PricingMainType['cardsPricing'];
};

const PlanCardsMobile = ({ data }: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(data?.[0]?.mostPopularIndex ?? 0);

  return (
    <div className={cn('lg:hidden', GridColFullWidth)}>
      <PlanCardsMobileTabs data={data} activeTabIndex={activeTabIndex} setActiveTabIndex={setActiveTabIndex} />
      <PlansMobile data={data} activeTabIndex={activeTabIndex} />
    </div>
  );
};

export default PlanCardsMobile;
